import React from 'react'

import { Form } from '_zari/core'

const FlagEnviarCorreoAutomaticoFormGroup = ({ value, onChange }) => {
  return (
    <Form.Checkbox
      name='ceck-enviarCorreoAutomatico'
      checked={value}
      onChange={onChange}
      id='checkbox-enviarCorreoAutomatico'
      label='Enviar correo automático'
    />
  )
}

export default FlagEnviarCorreoAutomaticoFormGroup
